import { render, staticRenderFns } from "./micoapp_point.vue?vue&type=template&id=34edc5cd&scoped=true"
import script from "./micoapp_point.vue?vue&type=script&lang=js"
export * from "./micoapp_point.vue?vue&type=script&lang=js"
import style0 from "./micoapp_point.vue?vue&type=style&index=0&id=34edc5cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edc5cd",
  null
  
)

export default component.exports